import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { InitiativeComment } from '@types';

export type PatchInitiativeCommentRequest = Omit<InitiativeComment, 'addedBy' | 'addedOn'>;

export const patchInitiativeComment = createPatchEndpoint<PatchInitiativeCommentRequest>(
	({ id, initiativeId }) => `/api/v3/initiatives/${initiativeId}/comments/${id}`
);
